import React from "react";
import heroBG from "../../assets/hero_bg2.png";
import { Link, useNavigate } from "react-router-dom";
import TourneyTentsLogoDarkBg from "../../assets/logos/tourneyTentsLogoDarkBackground.png";
import PartnerLogoCloud from "./PartnerLogoCloud";

export default function Hero({ setSearchQuery }) {
  const navigate = useNavigate();

  // INFO Handler for specific tournament button
  // const handleCTAButtonPress = (queryString) => {
  //   // Set the search query depending on the button pressed
  //   setSearchQuery(queryString);

  //   // Call handleNavigation when you want to navigate to /reservations
  //   navigate("/reservations");
  // };

  return (
    <div className="relative flex flex-col h-full overflow-hidden md:pt-12 pt-24">
      {/* full-bleed background */}
      <img
        src={heroBG}
        alt="Hero Background"
        className="absolute inset-0 -z-10 h-full w-full object-cover"
        style={{
          filter: [
            "sepia(100%)",
            "blur(2px)",
            "opacity(100%)",
            "saturate(300%)",
            "hue-rotate(180deg)",
            "brightness(35%)",
          ].join(" "),
        }}
        onContextMenu={(e) => e.preventDefault()}
      />

      {/* 1️⃣ Center-stacked content */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center text-center px-4">
        <img
          src={TourneyTentsLogoDarkBg}
          alt="Tourney Tents"
          className="mb-6 h-16 sm:h-20"
        />
        <h1 className="text-4xl sm:text-6xl font-bold text-white">
          Premier tournament concierge service
        </h1>
        <p className="mt-4 text-lg text-gray-300 max-w-xl">
          Tournaments should be a SPECTATOR sport and none of the hassle.
        </p>
        <Link to="/reservations">
          <button className="mt-8 rounded-md border-2 border-ttOrange-400 px-6 py-3 text-2xl font-semibold text-white hover:bg-ttOrange-400 hover:bg-opacity-25 transition">
            BOOK NOW
          </button>
        </Link>
      </div>

      {/* 2️⃣ Logo cloud at the bottom, full width, centered */}
      <div className="relative z-10 flex justify-center">
        <PartnerLogoCloud />
      </div>
    </div>
  );
}
